import { pbrExt } from './fragments/anisotropy-fragment.js';
import { _registerPbrExt } from './pbr-flags.js';

function setPbrAnisotropy(mat, anisotropy) {
  mat._anisotropy = anisotropy;
  _registerPbrExt(pbrExt);
}

export { setPbrAnisotropy };
//# sourceMappingURL=set-anisotropy.js.map
